import { TwcaMidLib } from './idpaas/mid';
import { TwcaCertLib } from './idpaas/cert';
import { TwcaVerifyLib } from './idpaas/verify';
import { TwcaAtlAgentLib } from './idpaas/atl-agent';
import { TwcaFormWindowLib } from './idpaas/form-window';
import packageJson from '../package.json';

// pre-expose old name
window.twcaMidLibSS = new TwcaMidLib();
window.twcaCertLibSS = new TwcaCertLib();
window.twcaVerifyLibSS = new TwcaVerifyLib();
window.twcaAtlAgentLibSS = new TwcaAtlAgentLib();
window.twcaFormWindowLibSS = new TwcaFormWindowLib();

// pre-expose old old name
window.twcaIDPaaSTwdsLib = new TwcaCertLib();

// 目前輸出設定不是 module，若有整合者需要此型式，再看怎設定 webpack.config.js
export default {
  TwcaIDPaaSLib: {
    version: packageJson.version,
    Mid: new TwcaMidLib(),
    Cert: new TwcaCertLib(),
    Verify: new TwcaVerifyLib(),
    AtlAgent: new TwcaAtlAgentLib(),
    FormWindow: new TwcaFormWindowLib()
  }
};
